<template>
    <div class="reward-box" >
        <img v-if="received != 1" class="box-img" :src="boxImg" alt="" />
        <img v-else class="box-img" :src="boxImg2" alt="" />

        <div class="overlay-text" >
            <div class="peopleText">{{ peopleCount }} {{ $t('common.pepole') }}</div>
            <div style="color: #ffffffa6;font-size: 12px;" class="rewardNum"
                :style="{ color: received == 1 ? '#f0a853' : '', fontWeight: received == 1 ? '600' : '100' }">
                <div>{{ Number(reward) }}</div>
            </div>
        </div>
    </div>





</template>

<script lang="ts">
import { URL } from 'uuid/dist/cjs/v35';
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: 'RewardBox',
    props: {
        peopleCount: {
            type: Number,
            required: true,
        },
        reward: {
            type: String,
            required: true,
        },
        arrow: {
            type: String,
            required: false,
        },
        down: {
            type: Boolean,
            required: false,
            default: false,
        },
        side: {
            type: String,
            required: false,
        },
        isInCorner: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false,
        },
        boxImg: {
            type: String,
            default: () => require('@/assets/bauDo/baoxiAsh.png'),
        },
        boxImg2: {
            type: String,
            default: () => require('@/assets/bauDo/baoxiang_01.png'),
        },
        received: {
            type: Number,
            default: () => 0,
            required: true,
        }
    },
})
</script>

<style scoped>
.reward-box {
    position: relative;
    width: 90px;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.rewardNum {
    width: 70%;
}

.box-img {
    width: 80%;
}

.completeBox {
    width: 17vw;
    height: 49px;
    background: green;
}

.arrow-img {
    width: 15px;
    height: 15px;
    margin-top: 5px;
    margin-left: 5px;
}

.arrow-img-down {
    width: 15px;
    height: 15px;
    margin-top: 8px;
}

.overlay-text {
    position: absolute;
    top: 60%;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 9.75px;
    color: white;
    text-align: center;
}

.peopleText {
    color: #fff;
    font-size: 9.75px;
    margin-bottom: 10%;
    width: 80%;
     white-space: nowrap;     
    overflow: hidden;        
    text-overflow: ellipsis;
}

@media (max-width: 400px) {
    .box-img {
        width: 60% !important;
    }
    .overlay-text{
        width: 60% !important;
    }
}

@media (max-width: 400px) {
    .peopleText {
        font-size: 8.5px;
        text-align: center;
        width: 60%;
        line-height: 7px;
    }
}

@media (min-width: 1440px) {
    .arrow-img-down {
        margin-right: 30px;
    }

    .arrow-img {
        margin-left: 15px;
        height: 15px;
    }

    .overlay-text {
        font-size: 0.5vw !important;
    }

    .rewardNum {
        font-size: 0.7vw !important;
    }
}

@media (min-width: 1920px) {
    .arrow-img-down {
        margin-right: 50px;
    }

    .arrow-img {
        margin-left: 1vw;
        height: 1vw;
        width: 1vw;
    }

    .arrow-img-down {
        margin-top: 0.5vw;
        margin-bottom: 0vw;
        height: 1vw;
        width: 1vw;
    }

    .overlay-text,
    .rewardNum {
        font-size: 0.5vw !important;
    }

}
</style>